"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
const react_1 = __importDefault(require("react"));
const Calendar_1 = __importDefault(require("../Calendar/Calendar"));
const consts_1 = require("../../common/consts");
require("./Events.scss");
const Events = () => {
    return (react_1.default.createElement("div", { className: "events-section", id: consts_1.SECTION_IDS.events },
        react_1.default.createElement("h2", null, "Events"),
        react_1.default.createElement("div", { className: "events--wrapper" },
            react_1.default.createElement("div", { className: "events--description" },
                react_1.default.createElement("p", null,
                    "Our weekly Thursday board game nights typically meets at",
                    ' ',
                    react_1.default.createElement("a", { href: "https://maps.app.goo.gl/ZvidgsxCbZERwPF69" }, "Dual Citizen Brewery"),
                    " in Saint Paul."),
                react_1.default.createElement("p", null, "We also host special events and game days throughout the month such as a trick taking game day or meetups in the north or south metro. Check out our calendar for upcoming events!")),
            react_1.default.createElement(Calendar_1.default, { calendarId: consts_1.CALENDAR_API_URL, view: "MONTH", tz: "America/Chicago", height: 700 }))));
};
exports.Events = Events;
